import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/askeper-perioperatif", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data) {
  const response = await http
    .putData(`/askeper-perioperatif/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/askeper-perioperatif/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/askeper-perioperatif/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/askeper-perioperatif`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByLaporanOperasi(lapOpId: number) {
  const response = await http
    .getData(`/laporan-operasi/${lapOpId}/askeper-perioperatif`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPre(id: number, data) {
  const response = await http
    .postData(`/askeper-perioperatif/${id}/sign-pre`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signIntra(id: number, data) {
  const response = await http
    .postData(`/askeper-perioperatif/${id}/sign-intra`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPost(id: number, data) {
  const response = await http
    .postData(`/askeper-perioperatif/${id}/sign-post`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/askeper-perioperatif/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  find,
  destroy,
  getByRegister,
  getByLaporanOperasi,
  signPre,
  signIntra,
  signPost,
  printPdf
};
